import { Port } from '../../types/models'
import { BatteryOptimizer2Config, BatteryOptimizer2Port, PortConfigBatteryOptimizer2, PortNumber } from '../../types/ports'
import { DeviceControl } from '../DeviceControl'
import { PortControl } from './PortControl'

/**
 * Controller for battery optimizer 2.0 (port 0x222).
 *
 * The port's configuration (`battery_optimizer2_conf`) is owned by the
 * firmware: the device plans and tunes it itself, the server only mirrors
 * what the device reports and never writes it back (the server rejects such
 * a flash). There is nothing for the customer to set, so the port is hidden
 * from the device configuration page and left out of the hardware-vs-settings
 * comparison — the firmware's copy is right by definition. In particular its
 * `enabled` bit is not read by any firmware release: battery control is gated
 * on the legacy port 0x220 `enabled` alone. We only wire the plan/info values
 * through for the front-page BatteryStateWidget.
 */
export class BatteryOptimizer2PortControl extends PortControl<BatteryOptimizer2Port, BatteryOptimizer2Config> {

  port: BatteryOptimizer2Port

  constructor(deviceControl: DeviceControl, port: Port) {
    super(deviceControl, port)
    this.port = port as BatteryOptimizer2Port
  }

  getDescription(): string { return this.app.t('Battery Optimizer 2.0') }

  getTypeName(): string { return this.app.t('PortType-BatteryOptimizer2') }

  get group(): string { return this.app.t('PortGroup-Optimization') }

  // Firmware-owned: not listed on the configuration page, not diffed against
  // hardware (hardwareDiff() reports FUTURE), never flashed.
  get isVisible() { return false }

  get noDiff() { return true }

  getConfigDefaults(): PortConfigBatteryOptimizer2 {
    return {
      enabled: false,
      battery_port: '22/0' as PortNumber,
      battery_dest: 0,
      battery_dest_kind: 'DEST_KIND_THIS_DEVICE',
      min_soc: 12,
      max_soc: 100,
    }
  }
}
